
import PageState from "./state";
import mutations from "./mutations";
import { getModule } from '@/store/store';
let u = navigator.userAgent;
let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
let device= isAndroid?"H5_ANDROID":"H5_IOS"
let API1 = {
	//ajax地址
	getSpeakerTypeList: `get /apis/tts-web-api/v1/speaker/getSpeakerType`, // 发音人类型
	getUserSpeakerByType: 'get /apis/tts-web-api/v1/mediaPlayer/getUserSpeakerByType', // 获取用户相关发音人类型
	getSpeakerByType: '/apis/tts-web-api/v1/mediaPlayer/getSpeakerByType', // 热榜
	getSpeakerEmotionList: `get /apis/tts-web-api/v1/speaker/getSpeakerEmotionList`, // 常用发音人
	getUserVipStatus: `get /apis/moyin-account/v1/vip/status`, // 用户权益
	getUsableSpeakerList: `get /apis/tts-web-api/v1/speaker/usable2`, // vip svip发音人
	getStoreSpeakerList: `get /apis/tts-web-api/v1/storeSpeaker/getStoreSpeaker2`, // 商店发音人
	getUsableSpeaker: `get /apis/tts-web-api/v1/mediaPlayer/getUsableSpeakers`, // 获取发音人
	getHistorySpeakerList: `get /apis/tts-web-api/v1/speaker/useHistory2`, // 常用发音人
	checkSensitive:`get /apis/tts-web-api/v1/articles/checkContent`,
	getPersonalSetting: `get /apis/moyin-account/v1/user/personalSetting/get`, // 获取用户个性化设置

	ttsSplitWord: { // 分词
		custom: true,
		url: '/nodetts-apis/tts/frontend/word',
		method: 'post'
	},
	updatePersonalSetting: { // 分词
		custom: true,
		url: '/apis/moyin-account/v1/user/personalSetting/update',
		method: 'post'
	},

	// 文章详情、更新、新增
	getArticleDetail: {
		custom: true,
		url: (data: any) => `/apis/tts-web-api/v1/articles/${data.id}`,
		method: 'get'
	},
	// 文章详情、更新、新增
	getcustomsms: {
		custom: true,
		url: `/tts/captcha?`,
		method: 'get'
	},
	// 文章详情、更新、新增
	getcaptchalogin: {
		custom: true,
		url: `/tts/captcha/login?`,
		method: 'get'
	},
	updateArticleDetail: {
		custom: true,
		url: (data: any) => `/apis/tts-web-api/v1/articles/${data.id}`,
		method: 'put',
		headers: {
			'content-type': 'multipart/form-data'
		}
	},
	updateSomeArticleDetail: {
		custom: true,
		url: (data: any) => `/apis/tts-web-api/v1/articles/update/${data.id}`,
		method: 'put',
		headers: {
			'content-type': 'multipart/form-data'
		}
	},
	saveArticleDetail: {
		custom: true,
		url: '/apis/tts-web-api/v1/articles',
		method: 'post',
		headers: {
			'content-type': 'multipart/form-data'
		}
	},
	//ai生成

	// 试听获取上一句、下一句、获取音频
	playFirst: {
		custom: true,
		url: `/apis/tts-web-api/v1/playDemo/playFirst`,
		method: 'post'
	},
	playNext: {
		custom: true,
		url: `/apis/tts-web-api/v1/playDemo/playNext`,
		method: 'post'
	},
	getAudition: {
		custom: true,
		url: `/nodetts-apis/tts/audition`,
		method: 'post',
		responseType: 'blob'
	},
	// 合成compose
	// 获取ssml
	getComposeSsml: `get /apis/tts-web-api/v1/playDemo/compose`,
	// 文章合成
	postArticleCompose: `post /nodetts-apis/tts/compose`,

	getArticlePrice: `get /apis/tts-web-api/v1/buy/audio/price`,
	// 获取发音人信息
	getSpeakerInfo: `get /apis/tts-web-api/v1/speaker/getSpeakerInfo`,
	// 失败回滚
	rollbackDemoCount: `get /apis/tts-web-api/v1/vip/rollbackDemoCount`,
	composeRollback: {
		custom: true,
		method: 'post',
		url: `/apis/tts-web-api/v1/buy/audio/pay/rollback`
	},
	// 获取音频oss地址
	getAudioUrl : `get /apis/tts-web-api/v1/audios/url`,
	// 保存oss地址
	postArticleOssPath: {
		custom: true,
		method: 'post',
		url: '/apis/tts-web-api/v1/audios',
		headers: {
			'content-type': 'multipart/form-data'
		}
	},
	// 登录用户会员状态
	getVipInfo: `get /apis/moyin-account/v1/vip/status`,
	// 专辑列表
	getMyCompanyList: `get /apis/tts-web-api/v1/company`,
	// 专辑状态
	getMyAlbumData: `get /apis/tts-web-api/v1/meet-voice/albums/my`,
	// 获取购买状态
	getPaymentStatus: `get /apis/tts-web-api/v1/buy/audio/couldPay`,
	// 检查token状态
	checkTokenStatus: `get https://passport.mobvoi.com/user/info/token`,
	// 兼容wechat-token
	checkWechatTokenStatus: `get /apis/moyin-account/v1/weChat/validateToken`,
	// 获取文字的发音
	getWordPinyinByText : `get /tts/getWords`,
	//
	payForFree: {
		custom: true,
		url: '/apis/tts-web-api/v1/buy/audio/pay/free',
		method: 'post'
	},
  // 查询会员渠道名称
  getChannelName: {
		custom: true,
    url: `/apis/moyin-account/v1/vip/getWxJsApiChannelName?`,
		method: 'get'
  },
  // 查询发音人列表
  getSpeakerListApi: {
		custom: true,
		url: `/apis/moyin-account/v1/channel/getChannelPresent?`,
		method: 'get'
  },

	//ai小魔生成提交排队任务
	submitAiTask: {
		custom: true,
    url: (data: any) =>`/apis/tts-web-api/v1/aiDoc/submitTask?projectId=${data.projectId}`,
		method: 'post'
	},
	//ai小魔生成查询任务结果
	getTaskResult: `get /apis/tts-web-api/v1/aiDoc/taskResult`,
	deleteTask: `get /apis/tts-web-api/v1/aiDoc/cancelTask`,
		//获取access_token
		getAccessToken:`get /tt/getAccessToken`,
		//检测内容
		checkContent:{
			custom: true,
			method: 'post',
			url:'/apis/moyin-tool/tt/antiDirt'
		}
	// checkContent:`get /apis/tt/checkContent`
    ,
	getStoreSearchCriteria: `get /apis/tts-web-api/v1/storeSpeakerV2/getStoreSearchCriteria`,
    //音量更新
    updateHistoryVolume: {
        custom: true,
        method:'post',
        url:`/apis/tts-web-api/v1/history/volume`
    },
    //获取用户历史设置信息
    getUserHistory:`get /apis/tts-web-api/v1/history`,
	//ai小魔用户反馈
	feedbackSubmit:{
        custom: true,
        method:'post',
        url: (data: any) =>`/apis/tts-web-api/v1/articles/feedback?choice=${data.choice}&originalText=${data.originalText}&description=${data.description}`
    }
};



let API2 = {
	...API1
	//网关
	// getAllBusDomainList: `post api/EmpPlatform/SMC180320000001/getUserCompanyList`,
};
let APIS = process.env.NODE_ENV == 'development' ? API1 : API2;

export default {
	...getModule({
		state: new PageState(),
		mutations,
		actions: {},
		APIS,
		name: "indexPage"
	})
};
